// Core
import {authconfig} from './authconfig';
import {coreconfig} from './coreconfig';

// App
import {mainconfig} from './mainconfig';
import {financeconfig } from './financeconfig';
import {budgetconfig } from './budgetconfig';
import {formsconfig } from './formsconfig';
import {activityconfig} from './activityconfig';
import {kpisconfig} from './kpisconfig';
import {filesconfig } from './filesconfig';
import {bieconfig} from './bieconfig'

// Tools
import {reportconfig} from './reportconfig';
import {uploadconfig} from './uploadconfig';
import {apisconfig } from './apisconfig';
import {uiuxconfig} from './uiuxconfig';
import {eventsconfig} from './eventsconfig';
import {flowsconfig} from './flowsconfig';

export const serviceconfig = {
  ...authconfig,
  ...coreconfig,
  
  ...mainconfig,
  ...financeconfig,
  ...budgetconfig,
  ...formsconfig,
  ...activityconfig,
  ...kpisconfig,
  ...filesconfig,
  ...bieconfig,

  ...reportconfig,
  ...uploadconfig,
  ...apisconfig,
  ...uiuxconfig,
  ...eventsconfig,
  ...flowsconfig,
};
